import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const EmailPreferencesApi = {
    get: (options?: BaseApiQueryOptions) => apiQueryOptions(['emailPreferences', 'get'], (api) => api.emailPreferences.get(), options),
    set: (options?: BaseApiMutationOptions<ApiClient['emailPreferences']['set']>) => apiMutationOptions((api) => api.emailPreferences.set, options)
};
